import type { FragmentType } from "@/generated";
import type { DocumentTypeDecoration } from "@graphql-typed-document-node/core";

export interface PiniaStore {
  $reset(): void;
}

export type ElementOfArray<T> = T extends (infer U)[] ? U : never;

export const isString = (value: unknown): value is string =>
  typeof value === "string";

export type GqlFragmentType<T extends DocumentTypeDecoration<any, any>> =
  FragmentType<T>;

export type NullableGqlFragmentType<
  T extends DocumentTypeDecoration<any, any>,
> = T | FragmentType<T> | null | undefined;
